import { call, put, takeLatest } from "redux-saga/effects";
import { reportTamThuApi } from "../../../api/report/reportTamThuApi";
import { IReportTamThuRequest } from "../../../model/request/report/IReportTamThuRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IReportTamThuViewModel } from "../../../model/respone/report/IReportTamThuRespone";
import {
  eReportTamThuActionIds,
  IReportTamThuActionTypes,
} from "../../action-types/report/IReportTamThuActionTypes";
import { rootActions } from "../../actions/rootActions";
import { IPagingResult } from "../../../model/respone/IPagingResult";

export function* reportTamThuSaga(): any {
  yield takeLatest(eReportTamThuActionIds.LOAD_START, loadWorker);
}

function* loadWorker(action: IReportTamThuActionTypes): any {
  const request = action.payload as IReportTamThuRequest;
  const res: IBaseRespone = yield call(reportTamThuApi.SelectByPaging, request);
  if (res.is_success) {
    const data: IPagingResult<IReportTamThuViewModel[]> = res.data;
    yield put(rootActions.report.reportTamThu.LOAD_SUCCESS(data));
  } else {
    yield put(
      rootActions.report.reportTamThu.LOAD_ERROR(res.message ?? "Có lỗi")
    );
  }
}
